module.exports = __webpack_public_path__ + "static/Group 7134-9efe58fb9faa91ff3ea5d9a5a41c6ed8.png";